import { DateTime } from 'luxon'

export const NO_EXPIRY = '—'
export const DEFAULT_ORIGIN = 'Default'
const EXPIRY_FORMAT = 'yyyy-MM-dd'
const OWNERSHIP_RECORD_PREFIX = '_cf-custom-hostname'
const CERTIFICATE_VALIDATION_RECORD_PREFIX = '_acme-challenge'

export function buildOwnershipRecordName(hostname: string): string {
    return `${OWNERSHIP_RECORD_PREFIX}.${hostname}`
}

export function buildCertificateValidationRecordName(hostname: string): string {
    return `${CERTIFICATE_VALIDATION_RECORD_PREFIX}.${hostname}`
}

export function earliestExpiry(customHostname: any): string {
    const certificates: { expires_on: string }[] = customHostname.ssl?.certificates ?? []
    const expiries = certificates.map((certificate) => DateTime.fromISO(certificate.expires_on, { zone: 'utc' }))
    if (expiries.length === 0) {
        return NO_EXPIRY
    }
    const earliest = DateTime.min(...expiries)

    return earliest.toFormat(EXPIRY_FORMAT)
}

export function validationMessages(customHostname: any): string[] {
    const validationErrors: { message: string }[] = customHostname.ssl?.validation_errors ?? []

    return validationErrors.map((validationError) => validationError.message)
}

export function originServerLabel(origin: string | undefined): string {
    return origin || DEFAULT_ORIGIN
}
